import React from 'react';

const PlanActions = ({ button }) =>
  <div className="plan-ctas-cont">
    <button className="plan-cta btn btn-lg btn-success js-start-now" data-plan-checkout>
      {button.text}
    </button>
    <a
      className="plan-cta btn btn-lg btn-success js-buy-now hide"
      href="//manage.auth0.com/#/account/billing/subscription"
    >
      {button.text}
    </a>
    {button.customText &&
      <button className="plan-cta btn btn-lg btn-success js-plan-contact-sales custom-deal open-contact-form-modal">
        {button.customText}
      </button>}
  </div>;

export default PlanActions;



// WEBPACK FOOTER //
// ./src/components/pricingPlans/components/planBox/PlanActions.js